<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/order-templates/shared/order-template-widget/order-template-widget.component.ts
-->
<ng-template #anchor></ng-template>
